// ════════════════════════════════════════════════════════════
//  theme.js — the two tokens THE MARK's kit asks a title for
// ════════════════════════════════════════════════════════════
//  The vendored AchievementBadgeBook.js (behind the Mark) imports
//  { GM, MANUSCRIPT_BG } from "./theme" — every title that carries the
//  full Mark has its own theme.js. Shatterproof's UI is its own CSS
//  (App.css), so this file holds ONLY what the kit reads: the Empire's
//  Gilded Obsidian palette, copied from app-annihilation/src/theme.js
//  (the reference title for the Mark stack). Not used by the game itself.
// ════════════════════════════════════════════════════════════
export const GM = {
  page: "#070410", pageWarm: "#0d0918", pageMid: "#150e26", pageLight: "#1e1636", pageBorder: "#392a52",
  inkGold: "#c8963c", inkGoldBright: "#e8b84b", inkGoldDim: "#8a6520", inkBrown: "#6d6288", inkRed: "#8b2020",
  vellum: "#ece2cc", vellumDim: "#b3a68c", vellumFaint: "#7d7191",
  silver: "#b8c0d4", silverBright: "#e2e8f4", silverDim: "#5d637a",
  amethyst: "#8b5cf6", amethystBright: "#c084fc", amethystDim: "#3b2a63",
  rose: "#f472b6", roseDim: "#9d4a76",
  font: "'Cinzel', 'Palatino Linotype', serif",
  fontD: "'Cinzel Decorative', 'Palatino Linotype', serif",
  fontBody: "'Cormorant Garamond', 'Palatino Linotype', serif",
  fontUI: "'Inter', 'Segoe UI', system-ui, sans-serif",
};
export const MANUSCRIPT_BG = [
  "repeating-linear-gradient(135deg, transparent 0px, transparent 26px, rgba(192,132,252,0.028) 26px, rgba(192,132,252,0.028) 27px)",
  "radial-gradient(ellipse at 28% 0%, rgba(139,92,246,0.13) 0%, transparent 52%)",
  "radial-gradient(ellipse at 78% 92%, rgba(59,42,99,0.30) 0%, transparent 55%)",
  "radial-gradient(ellipse at 8% 80%, rgba(139,32,32,0.07) 0%, transparent 45%)",
  "#070410",
].join(", ");
